export default __webpack_public_path__ + "static/media/Astro_Tina_TU.fc0cd447.gif";